import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Grid, SxProps, Typography } from '@mui/material';
import { FC } from 'react';
import SideContentCard from './SideContentCard';
import { sxs } from '@utils/mui/sx';

const cardSx: SxProps = {
    '&:hover, &:focus': {
        backgroundColor: 'grey.600',
    },
    border: 'none',
    color: 'text.secondary',
    mb: 1,
};

interface OpenInNewCardProps {
    dataTestId?: string;
    label: string;
    onClick?: () => void;
    overTitle?: string;
    sx?: SxProps;
}

const OpenInNewCard: FC<OpenInNewCardProps> = ({
    dataTestId,
    label,
    onClick,
    overTitle,
    sx = {},
}) => (
    <SideContentCard dataTestId={dataTestId} onClick={onClick} sx={sxs([cardSx, sx])}>
        <Grid container>
            <Grid sx={{ alignItems: 'center', color: 'grey.300', display: 'flex', mr: 2 }} item>
                <OpenInNewIcon />
            </Grid>
            <Grid item xs>
                {overTitle && (
                    <Typography sx={{ color: 'grey.300', fontSize: 12 }}>{overTitle}</Typography>
                )}
                <Typography component="h4" sx={{ fontWeight: 'medium' }}>
                    {label}
                </Typography>
            </Grid>
        </Grid>
    </SideContentCard>
);

export default OpenInNewCard;
